"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddressFormat = void 0;
/**
 * Validates address format: "address line 1, zipCode City, country"
 * @param address - The address string to validate
 * @returns boolean - true if valid, false otherwise
 */
const validateAddressFormat = (address) => {
    if (!address || typeof address !== "string") {
        return false;
    }
    const trimmedAddress = address.trim();
    // Split by commas and validate each part
    const parts = trimmedAddress.split(",").map((part) => part.trim());
    const [addressLine1, zipCityPart, country] = parts;
    // Check if address line 1 is not empty
    if (!addressLine1 || addressLine1.length === 0) {
        return false;
    }
    // More flexible regex that handles both formats:
    // 1. "3333 Meredith" (zip at start)
    // 2. "Meredith Victoria 3333" (zip at end)
    // 3. "Meredith" (no zip code)
    const zipCityRegex = /^(\d{3,10}\s+.+)|(.+\s+\d{3,10})|(.+)$/u;
    const zipCityMatch = zipCityRegex.test(zipCityPart);
    if (!zipCityMatch) {
        return false;
    }
    // Check if country is not empty
    if (!country || country.length === 0) {
        return false;
    }
    return true;
};
exports.validateAddressFormat = validateAddressFormat;
